import { useState, useMemo } from 'react';

/**
 * Custom hook for table search functionality
 * Filters data based on search query across specified fields
 */
export function useTableSearch(data, searchFields = []) {
  const [searchQuery, setSearchQuery] = useState('');

  // Filter data based on search query
  const filteredData = useMemo(() => {
    if (!searchQuery.trim()) {
      return data;
    }

    const searchLower = searchQuery.toLowerCase();

    return data.filter((item) => {
      return searchFields.some((field) => {
        const value = field.split('.').reduce((obj, key) => obj?.[key], item);
        return value?.toString().toLowerCase().includes(searchLower);
      });
    });
  }, [data, searchQuery, searchFields]);

  const handleSearchChange = (query) => {
    setSearchQuery(query);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  return {
    searchQuery,
    filteredData,
    setSearchQuery: handleSearchChange,
    clearSearch,
  };
}
